import React from 'react'

import mouse from './../../../UI/general/Mouse_clic.svg'

interface Props {
}

interface State {
  showDragAnimation: boolean
}

class Drag extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      showDragAnimation: false
    }
  }

  render(): React.ReactNode {
      return(
        <div className={this.state.showDragAnimation ? 'drag-animation fade-in':'drag-animation fade-out'}>
          <img src={mouse} alt=''/>
          <div className='drag-animation-text'>Arrastra el cursor para rotar 360°</div>
        </div>
      )
  }
}

export default Drag